import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { showNetworkErrorToast } from 'components/Toast';
import { ToastId } from 'components/Toast/Toast';
import { useOnline } from './useOnline';

export const useOfflineNetworkToast = (): void => {
  const { isOnline } = useOnline();

  useEffect(() => {
    if (!isOnline) {
      return showNetworkErrorToast({
        autoClose: false,
        toastId: ToastId.failedInternet,
      });
    }
    toast.dismiss(ToastId.failedInternet);
  }, [isOnline]);
};
